var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRocket(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3054_8223)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.2705 22.0049L0.956798 33.3186",
    stroke: "url(#paint0_linear_3054_8223)",
    strokeWidth: 3.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.11104 10.7615C8.4238 9.44876 10.2043 8.71126 12.0608 8.71126L17.0809 8.71126L9.55728 16.2349L3.32763 16.2349C2.70399 16.2349 2.39168 15.4809 2.83265 15.0399L7.11104 10.7615Z",
    fill: "#DB2417"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5144 27.1663C24.8271 25.8535 25.5646 24.0731 25.5646 22.2166L25.5646 17.1965L18.041 24.7201L18.041 30.9497C18.041 31.5734 18.795 31.8857 19.236 31.4447L23.5144 27.1663Z",
    fill: "#DB2417"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4229 17.7622L16.514 22.8534L14.2113 24.3885C13.5767 24.8116 12.7317 24.7279 12.1924 24.1886L10.0876 22.0838C9.54831 21.5445 9.46464 20.6995 9.8877 20.0649L11.4229 17.7622Z",
    fill: "#132234"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_3054_8223)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.3255 7.33513C19.4015 5.25916 22.0086 3.79439 24.8615 3.10121L28.0972 2.315C30.4266 1.74901 32.5283 3.85071 31.9623 6.18007L31.1761 9.4158C30.4829 12.2687 29.0181 14.8758 26.9422 16.9518L19.3436 24.5504C18.4063 25.4876 16.8867 25.4876 15.9495 24.5504L9.72691 18.3278C8.78965 17.3906 8.78965 15.871 9.72691 14.9337L17.3255 7.33513Z",
    fill: "#B3D2DE"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 20.0137,
    y: 12.7734,
    width: 2.11013,
    height: 15.2,
    rx: 1.05507,
    transform: "rotate(45 20.0137 12.7734)",
    fill: "#DB2417"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_3054_8223",
    x: 9.02441,
    y: 2.22168,
    width: 23.0312,
    height: 23.0317,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -3.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.699186 0 0 0 0 0.699186 0 0 0 0 0.699186 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3054_8223"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3054_8223",
    x1: 11.4927,
    y1: 23.4898,
    x2: 3.3152,
    y2: 31.6673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBFF00",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3054_8223"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white",
    transform: "translate(0 0.00195312)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocket);
export default __webpack_public_path__ + "static/media/rocket.f6911e2800c6df698b8108552e1d6514.svg";
export { ForwardRef as ReactComponent };